import { defineNuxtPlugin } from '#imports';
import Tealium from '@/lib/tealium';

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.provide('tealium', Tealium);
});
